import { gql } from '@apollo/client';

export const SHARE_STORY = gql`
  mutation shareStory($input: ShareStoryInput!) {
    shareStory(input: $input) {
      success
      sharedToUsers
      sharedToCircle
    }
  }
`;
